<ngx-charts-bar-vertical [animations]="false" [barPadding]="0" [results]="data" [scheme]="colors" [view]="[992,400]"
  [xAxis]="true" [xAxisTickFormatting]="format" [yAxis]="true" [yAxisLabel]="units">
  <ng-template #tooltipTemplate let-model="model">
    <!-- Bar chart model doesn't convey the data series additional information. -->
    {{model.name | datestamp}} : {{model.value}}{{units}}
  </ng-template>
</ngx-charts-bar-vertical>